import React from 'react'
import { Link } from 'gatsby'
import LayoutSplash from '../layouts/splash'
import SEO from '../components/seo'
import HeaderSplash from '../components/headerSplash'
import Content from '../components/content'
import styled from 'styled-components'
import P from '../components/paragraph'
import { animated } from 'react-spring'
import useIsInViewport from 'use-is-in-viewport'
import useAnimate from '../hooks/useAnimate'

const Container = styled(Content)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`

const IndexPage = () => {
  const [isInViewport, animatedDiv] = useIsInViewport()
  const fadeInTrigger = useAnimate({ trigger: isInViewport })

  return (
    <>
      <SEO title="Mandjo &amp; Alina's Wedding: 17 July 2021" noTemplate />
      <HeaderSplash />
      <LayoutSplash>
        <Container>
          <animated.div ref={animatedDiv} style={fadeInTrigger()} >
            <h2>17 July 2021</h2>
            <P narrow>
              We are looking forward to spend our big day with you. Click through for more information.
            </P>
            <Link to='/wedding'>More about our special day &rarr;</Link>
          </animated.div>
      
        </Container>

   
      </LayoutSplash>
    </>
  )
}

export default IndexPage
